import { connectRefinementList } from 'instantsearch.js/es/connectors'
import { groupBy, map, last } from 'underscore'
import emitter from '../emitter'

const initItems = { expertise: [], type: [] }

const renderRefinementList = (renderOptions, isFirstRender) => {
  const {
    items,
    refine,
    widgetParams,
  } = renderOptions

  const labels = {
    'activity-report': 'Rapports d\'activité',
    study: 'Études',
    'btob-news': 'BtoB News',
    'practical-guide': 'Notes adhérents',
    'barometer-activity': 'Baromètre d\'activité',
    'thematic-brochure': 'Plaquettes thématiques',
    article: 'Actualités',
    agenda: 'Agenda',
    event: 'Événements',
    page: 'Pages',
  }

  if (isFirstRender) {
    const div = document.createElement('div')
    div.classList.add('ais-RefinementList')
    div.innerHTML = '<ul class="ais-RefinementList-list"></ul>'

    widgetParams.container.appendChild(div)
  }

  // specific for search page otherwise never get full list of filters available if we have a query / parameter in url and filters are empty on no results
  if (widgetParams.isSearch && initItems.type.length === 0) {
    initItems.type = [
      { count: 0, highlighted: 'activity-report', isRefined: false, label: 'activity-report', value: 'activity-report' },
      { count: 0, highlighted: 'agenda', isRefined: false, label: 'agenda', value: 'agenda' },
      { count: 0, highlighted: 'article', isRefined: false, label: 'article', value: 'article' },
      { count: 0, highlighted: 'barometer-activity', isRefined: false, label: 'barometer-activity', value: 'barometer-activity' },
      { count: 0, highlighted: 'btob-news', isRefined: false, label: 'btob-news', value: 'btob-news' },
      { count: 0, highlighted: 'event', isRefined: false, label: 'event', value: 'event' },
      { count: 0, highlighted: 'page', isRefined: false, label: 'page', value: 'page' },
      { count: 0, highlighted: 'practical-guide', isRefined: false, label: 'practical-guide', value: 'practical-guide' },
      { count: 0, highlighted: 'study', isRefined: false, label: 'study', value: 'study' },
      { count: 0, highlighted: 'thematic-brochure', isRefined: false, label: 'thematic-brochure', value: 'thematic-brochure' },
    ]
  }

  // get initFilters for lists
  if (items.length > 0) {
    if (widgetParams.isSearch === undefined && (initItems.expertise.length === 0 || initItems.type.length === 0)) {
      initItems[widgetParams.attribute] = items
    }
  }

  let newItems = map(groupBy(initItems[widgetParams.attribute].concat(items), 'value'), last)

  if (widgetParams.isType) {
    newItems = newItems.sort((a, b) => {
      if (labels[a.label].replace('É', 'E') < labels[b.label].replace('É', 'E')) return -1
      if (labels[a.label].replace('É', 'E') > labels[b.label].replace('É', 'E')) return 1
      return 0
    })
  }

  widgetParams.container.querySelector('ul').innerHTML = newItems
    .map(
      item => `
        <li class="ais-RefinementList-item">
          <label class="ais-RefinementList-label">
            <input type="checkbox" ${item.isRefined ? 'checked' : ''} class="ais-RefinementList-checkbox" value="${item.value}" />
            <span class="ais-RefinementList-labelText">${widgetParams.isType ? labels[item.label] : item.label}</span>
          </label>
        </li>
      `,
    )
    .join('');

  [...widgetParams.container.querySelectorAll('input')].forEach(element => {
    element.addEventListener('change', event => {
      event.preventDefault()
      refine(event.currentTarget.value)

      emitter.trigger('nbSearchFilters', {
        nb: widgetParams.container.querySelectorAll('input:checked').length,
      })
    })
  })
}

const customRefinementList = connectRefinementList(renderRefinementList)

export default customRefinementList
